export function isLastTabbable(
  container: HTMLElement,
  element: HTMLElement | EventTarget
) {
  const tabbables: HTMLElement[] = []
  container
    .querySelectorAll(
      '[tabindex]:not([tabindex="-1"]), button:not([disabled]), [href], input, select, textarea'
    )
    .forEach((el) => {
      tabbables.push(el as HTMLElement)
    })

  const last = tabbables[tabbables.length - 1]

  return last === element
}
